import safetyBarrierDefaultOptions from './defaultOptions';
import SafetyBarrierObject from './safety-barrier.object';

export {
  SafetyBarrierObject,
  safetyBarrierDefaultOptions
};



// WEBPACK FOOTER //
// ./src/object-view/generators/safety-barrier/index.js